import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa'
import $ from 'jquery';

export default class Navbar extends Component {
    state = {
        isMounted: false,
        url: "/projekty",
        logo: "https://www.nabytekbatka.cz/logocodeB.svg"
    };


    componentDidMount() {
        this.checkWidth()
        this.setState(prevState => ({ isMounted: !prevState.isMounted }))

    }

    whereAmI = () => {
        if ($(location).attr('href') === "https://nabytekbatka.cz/projekty") {
            this.setState({ url: "/" })
        } else if ($(location).attr('href') === "https://nabytekbatka.cz/projekty:slug") {
            this.setState({ url: "/projekty" })
        }
    }

    checkWidth = () => {
        if ($(window).width() <= 768) {
            console.log($(window).width())
            this.setState({ logo: "https://www.nabytekbatka.cz/BatkaSmall.svg" })
        } else if ($(window).width() <= 1440) {
            console.log($(window).width())
            this.setState({ logo: "https://www.nabytekbatka.cz/nabytekBatka.svg" })
        } else if ($(window).width() > 1440) {
            console.log($(window).width())
            this.setState({ logo: "https://www.nabytekbatka.cz/logocodeB.svg" })
        }
    }

    render() {
        return (
            <nav className="navbar navbarr">
                <div className="navbarr-container">
                    <div className="logo-container">
                        <Link to="/">
                            {/* classname z propu > meneni loga podle velikosti obrazovky */}
                            <img className="logo" src={this.state.logo} alt="logo"></img>
                        </Link>
                    </div>
                    <button type="button" className="nav-btn">
                        <a href={this.state.url} onClick={this.whereAmI}><FaArrowLeft className="nav-icon">
                        </FaArrowLeft></a>
                    </button>
                </div>
            </nav>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/NavbarClear.js